import React from 'react';

import BannerStyleDownloadButtonActionAccordion, {
  ButtonData,
} from '../BannerStyleDownloadButtonActionAccordion';
import ActionStateBannerStyleDownloadButton from '../ActionStateBannerStyleDownloadButton';
import TreatmentStepDownloadButton from '../TreatmentStepDownloadButton';
import NutritionAdviceActionPlanDownloadButton from '../NutritionAdviceActionPlanDownloadButton';

import { TREATMENT_DOWNLOAD_BUTTON_TYPES } from '../../app/constants/treatment';

export interface TreatmentBannerStyleDownloadButtonActionAccordionProps {
  treatmentType?: string;
  data?: any;
  error?: boolean;
  activeStateTagText?: string;
  number: string;
  title: string;
  subtitle?: string;
  text?: string;
  isOpenByDefault?: boolean;
  completed: boolean;
  stepId?: string;
  className?: string;
  dispatch?: any;
  buttonsData: ButtonData[];
}

const TreatmentBannerStyleDownloadButtonActionAccordion: React.FC<
  TreatmentBannerStyleDownloadButtonActionAccordionProps
> = ({
  activeStateTagText,
  number,
  title,
  subtitle,
  text,
  isOpenByDefault,
  completed,
  buttonsData,
  stepId,
  className,
}) => {
  const renderDownloadButton = (button: ButtonData) => {
    const commonProps = {
      fileName: button.fileName,
      stepId,
      title: button.label,
      subtitle: button.text,
      imageUrl: button.imageUrl,
      imageAlt: button.imageAlt,
      className: button.className,
    };

    switch (button.type) {
      case TREATMENT_DOWNLOAD_BUTTON_TYPES.DOWNLOAD_TREATMENT_PRESCRIPTION:
        return <TreatmentStepDownloadButton {...commonProps} />;

      case TREATMENT_DOWNLOAD_BUTTON_TYPES.DOWNLOAD_ACTION_PLAN:
      case TREATMENT_DOWNLOAD_BUTTON_TYPES.DOWNLOAD_SESSION_DOCUMENTATION:
        return (
          <NutritionAdviceActionPlanDownloadButton
            {...commonProps}
            type={button.type}
          />
        );

      default:
        return null;
    }
  };

  return (
    <BannerStyleDownloadButtonActionAccordion
      activeStateTagText={activeStateTagText}
      number={number}
      title={title}
      subtitle={subtitle}
      text={text}
      isOpenByDefault={isOpenByDefault}
      completed={completed}
      className={className}
    >
      {buttonsData.map((button, index) => (
        <ActionStateBannerStyleDownloadButton
          key={`${button.type}-${index}`}
          title={button.label}
          subtitle={button.text}
          imageUrl={button.imageUrl}
          imageAlt={button.imageAlt}
          actionState={button.state}
          onClick={button.onClick}
          error={button.error}
        >
          {renderDownloadButton(button)}
        </ActionStateBannerStyleDownloadButton>
      ))}
    </BannerStyleDownloadButtonActionAccordion>
  );
};

export default TreatmentBannerStyleDownloadButtonActionAccordion;
